'use client';

import { useSocketManagerContext } from '../providers/context';

/**
 * Access all WebSocket connections (Indian prices, trades, US prices).
 *
 * @example
 * const { isPricesConnected, isUSPricesConnected } = useWebSocket();
 */
export function useWebSocket() {
  const context = useSocketManagerContext();

  return {
    pricesConnection: context.pricesConnection,
    tradesConnection: context.tradesConnection,
    usPricesConnection: context.usPricesConnection,
    isPricesConnected: context.isPricesConnected,
    isTradesConnected: context.isTradesConnected,
    isUSPricesConnected: context.isUSPricesConnected,
  };
}

/**
 * Access Indian stocks prices connection only.
 *
 * @example
 * const { connection, isConnected } = usePricesConnection();
 */
export function usePricesConnection() {
  const { pricesConnection, isPricesConnected } = useSocketManagerContext();
  return { connection: pricesConnection, isConnected: isPricesConnected };
}

/**
 * Access Indian stocks trades connection only.
 *
 * @example
 * const { connection, isConnected } = useTradesConnection();
 */
export function useTradesConnection() {
  const { tradesConnection, isTradesConnected } = useSocketManagerContext();
  return { connection: tradesConnection, isConnected: isTradesConnected };
}

/**
 * Access US stocks prices connection only.
 *
 * @example
 * const { connection, isConnected } = useUSPricesConnection();
 */
export function useUSPricesConnection() {
  const { usPricesConnection, isUSPricesConnected } = useSocketManagerContext();
  return { connection: usPricesConnection, isConnected: isUSPricesConnected };
}
